import BossModel from '@/models/BossModel'
import Presentation from "@/models/Proposal/Presentation/Presentation";
import Product from "@/models/Proposal/Product/Product";

export default class OptionalDay extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'proposal/presentation/optional-day';

    /**
     *
     * @type {string}
     */
    static entity = 'proposalPresentationOptionalDays';

    static fields() {
		return {
			id: this.number(null).nullable(),
			proposal_presentation_id: this.number(null).nullable(),
            proposal_product_id: this.number(null).nullable(),
			title: this.attr(null),
			text: this.attr(null),
			sort_order: this.number(null).nullable(),
            presentation: this.belongsTo(Presentation, 'proposal_presentation_id'),
            product: this.belongsTo(Product, 'proposal_product_id')
		}
	}

    /**
     *
     * @param presentationId
     * @returns {*}
     */
    static loadByPresentation(presentationId) {
        return this.api()
            .limit(0)
            .where('proposal_presentation_id', presentationId)
            .get(true);
    }


    /**
     *
     * @returns {null|*}
     */
    GetNext() {
        let items = this.Presentation().OptionalDays();
        let currentIndex = items.findIndex(item => item.id === this.id);
        if (currentIndex < items.length - 1) {
            return items[currentIndex + 1];
        }

        return null;
    }

    /**
     *
     * @returns {boolean|*}
     */
    Presentation() {
        return this.getRelated('presentation');
    }

    /**
     *
     * @returns {boolean|*}
     */
    LineProduct() {
        return this.getRelated('lineProduct');
    }

    /**
     *
     * @param view
     * @returns {Promise<AxiosResponse<T>>}
     */
    Preview() {
        return this.constructor.api().action(this.id + '/preview').getSingle(false);
    }
}
